import { tsValidate_OptionalArray, tsValidateBoolean, tsValidateOptionalAnyNumber, tsValidateString, tsValidateTimestamp, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DataTypes } from '../encounter-events/bucket-dump-types.js';
const Validator_BucketMetadata_Snapshot = {
    bucketPath: tsValidateString(),
    bucketName: tsValidateString(),
    linkToBugReportData: tsValidateString(-1, false),
    dataType: tsValidateValue([...DataTypes]),
    projectId: tsValidateString(-1, false),
};
const Validator_EncounterExtraData = {
    age: tsValidateOptionalAnyNumber,
    gender: tsValidateString(-1, false),
    chiefComplaints: tsValidate_OptionalArray(tsValidateString()),
};
const Validator_OrganizationMetadata = {
    organizationId: tsValidateUniqueId,
    ehrInstanceId: tsValidateUniqueId,
    ehrInstallationId: tsValidateUniqueId,
    environmentId: tsValidateUniqueId,
    facilityId: tsValidateUniqueId,
    advisorConfigurationId: tsValidateUniqueId,
};
const Validator_MandatoryPropsEncounterSnapshot = {
    bucketMetadata: Validator_BucketMetadata_Snapshot,
    organizationMetadata: Validator_OrganizationMetadata,
    encounterExtraData: Validator_EncounterExtraData,
    encounterId: tsValidateUniqueId,
    patientId: tsValidateUniqueId,
    kbVersion: tsValidateString(),
    description: tsValidateString(),
    dateTime: tsValidateTimestamp(),
    encounterStartTime: tsValidateOptionalAnyNumber,
    refactoredSnapshot: tsValidateBoolean()
};
const Validator_GeneratedProps = {};
export const DBDef_EncounterSnapshot = {
    modifiablePropsValidator: Validator_MandatoryPropsEncounterSnapshot,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'encounter-snapshots',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'encounter-snapshots'
    },
    backend: {
        name: 'encounter-snapshots'
    },
    entityName: 'EncounterSnapshots',
    dependencies: {
        'organizationMetadata.organizationId': {
            dbKey: 'organizations',
            fieldType: 'string',
        },
        'organizationMetadata.environmentId': {
            dbKey: 'environments',
            fieldType: 'string',
        },
        'organizationMetadata.facilityId': {
            dbKey: 'facility',
            fieldType: 'string',
        },
        'organizationMetadata.advisorConfigurationId': {
            dbKey: 'advisor-configurations',
            fieldType: 'string',
        },
        'organizationMetadata.ehrInstallationId': {
            dbKey: 'ehr-installations',
            fieldType: 'string',
        },
    }
};
//# sourceMappingURL=db-def.js.map